export default class Breadcrumbs {
	static init() {
		this.separators = document.querySelectorAll(".breadcrumbs .separator");

		this.separators.forEach( (separator) => {

			separator.innerHTML = `<svg width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.24727 12.0601L6.16355 13L12.5 6.5L6.16355 0L5.24727 0.939693L10.0196 5.83517H0.5V7.16448H10.0196L5.24727 12.0601Z" fill="currentColor" />
</svg>`;

		});

	}

}
